import React from 'react';

import DispensaryCard from '../dispensaries/DispensaryCardTall';
import SecondaryHeader from '../styleguide/SecondaryHeader';
import PropTypes from 'prop-types';

import styles from '../dispensaries/Dispensaries.module.css';

const FilteredDispensaries = (
{
  dispensaries,
  zipCode,
  showMatching=true
}) => {
  
  const matchingDispensaries = dispensaries.filter(disp => {
    const delivery_zip_codes = disp.delivery_zip_codes || [];
    return showMatching
      ? delivery_zip_codes.indexOf(zipCode) > -1  
      : delivery_zip_codes.indexOf(zipCode) === -1;
  });
  
  const noteStyle = showMatching ? styles.deliveryEnabled : styles.deliveryDisabled;
  const deliveryNote = showMatching 
                     ? `with delivery to ${zipCode}`
                     : `pickup only`;
    
  return ( matchingDispensaries.length > 0
      ? <>    
        <SecondaryHeader text="Shop by Dispensary">
          { zipCode && 
            <span className={noteStyle}>
              {deliveryNote}
            </span>
          }    
        </SecondaryHeader>  
        <div className={styles.dispensaryList}>
          { matchingDispensaries.map(disp => {
            return <DispensaryCard 
                     key={disp.id} 
                     dispensaryId={disp.id}
                     dispensaryName={disp.name}
                     dispensaryLogo={disp.image_urls.secondary}
                     createDate={disp.created_at}
                     dispensaryLocation={disp.location} />
          })}
        </div>
      </>
      : null    
  );
}

FilteredDispensaries.propTypes = {
  dispensaries: PropTypes.array, 
  zipCode: PropTypes.string,
  showMatching: PropTypes.bool
}

export default FilteredDispensaries;